/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */
import * as React from 'react';
import * as history from 'history';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { Home } from '../home';
import { AppEvents } from 'contexts/appEventsContext';

/** AppRootProps - Properties */
export interface AppRootProps {
  events: AppEvents;
}

/** AppRootState - State */
export interface AppRootState {
  readonly history: history.History;
}

/** AppRoot */
export class AppRoot extends React.Component<AppRootProps, AppRootState> {
  constructor(props: AppRootProps, ctx: any) {
    super(props, ctx);
    const historyImpl = history.createBrowserHistory({
      forceRefresh: false,      // Set true to force full page refreshes
      keyLength: 127,             // The length of location.key
    });

    this.state = {
      history: historyImpl,
    };
  }

  static childContextTypes = {
    history: () => null,
  };

  getChildContext() {
    return {
      history: this.state.history,
    };
  }

  Home = (params: { match: any, location: any }) => {
    return (<Home events={this.props.events} history={this.state.history} match={params.match} location={params.location} />);
  }

  render() {
    return (
      <Router history={this.state.history}>
        <Switch>
          <Route exact path="/not-found" component={() => (<h1>Not Found.</h1>)} />
          <Route path="/" component={this.Home} />
        </Switch>
      </Router>
    );
  }
}

export default AppRoot;



// WEBPACK FOOTER //
// ./src/views/appLoader/appRoot.tsx